(function () {
  const initProductsTabs = (section) => {
    if (!section || !section.classList.contains("popular-products-section")) {
      return;
    }

    const filterItems = section.querySelectorAll("[data-filter-target]");
    const productItems = section.querySelectorAll("[data-product-filter]");
    if (filterItems.length === 0 || productItems.length === 0) return;

    const sliderEl = section.querySelector(".js-section-card-slider");
    let updateSlider = false;

    const filterOnClick = (filterItem) => {
      const filterTarget = filterItem.dataset.filterTarget;
      if (!filterTarget) return;

      if (filterItem.classList.contains("active")) return;
      filterItems.forEach((item) => item.classList.remove("active"));

      productItems.forEach((item) => {
        item.style.display = "none";

        const productFilter = item.dataset.productFilter || "";
        const filterValues = productFilter.split(",").map((v) => v.trim());

        if (filterValues.includes(filterTarget)) {
          filterItem.classList.add("active");
          item.style.display = "";
          updateSlider = true;
        }
      });

      if (updateSlider) {
        if (sliderEl && sliderEl.swiper) {
          sliderEl.swiper.update();
        }
      }
    };

    filterItems.forEach((filterItem) => {
      filterItem.addEventListener("click", () => {
        filterOnClick(filterItem);
      });
    });
  };

  initProductsTabs(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initProductsTabs(event.target);
  });
})();
